import { render, staticRenderFns } from "./SocialKpiComponent.vue?vue&type=template&id=70d2b2ab&scoped=true"
import script from "./SocialKpiComponent.vue?vue&type=script&lang=js"
export * from "./SocialKpiComponent.vue?vue&type=script&lang=js"
import style0 from "./SocialKpiComponent.vue?vue&type=style&index=0&id=70d2b2ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d2b2ab",
  null
  
)

export default component.exports